import React, { useState, useRef, useEffect } from 'react';
import { Palette, Check } from 'lucide-react';
import { useTheme, THEMES } from '../theme';

export default function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen(!open)} data-testid="theme-switcher" className="chip px-2.5 py-1.5 text-slate-200">
        <Palette className="w-4 h-4" />
      </button>
      {open && (
        <div data-testid="theme-menu" className="absolute right-0 mt-2 w-52 glass rounded-2xl border border-white/10 p-2 z-50">
          <div className="kicker px-2 py-1.5">Theme</div>
          {THEMES.map((th) => (
            <button key={th.key} onClick={() => { setTheme(th.key); setOpen(false); }} data-testid={`theme-${th.key}`}
              className={`w-full flex items-center gap-3 px-2 py-2 rounded-xl text-sm hover:bg-white/5 ${theme === th.key ? 'text-jade' : 'text-slate-300'}`}>
              <span className="flex gap-1">
                <span className="w-4 h-4 rounded-full border border-white/20" style={{ background: th.swatch[0] }} />
                <span className="w-4 h-4 rounded-full border border-white/20" style={{ background: th.swatch[1] }} />
              </span>
              <span className="flex-1 text-left">{th.name}</span>
              {theme === th.key && <Check className="w-4 h-4" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
